module.exports = __webpack_public_path__ + "static/1202939384.330997c1.jpg";